import React, { useMemo } from 'react'
import Common from './common/EventsGrid'
import Zuiderhuis from './zuiderhuis/EventsGrid'

const EventsGridLoader = ({
  id,
  items,
  title,
  isLessThanLaptop,
  language,
  organizationSlug,
  itemsPerRow,
  itemsPerPage,
}) => {
  // Memoize the lazy-loaded component based on organizationSlug
  const EventGridLazyLoaded = useMemo(() => {
    if (!organizationSlug) return null
    switch (organizationSlug) {
      case 'zuiderhuis':
        return Zuiderhuis
      default:
        return Common
    }
  }, [organizationSlug])

  return (
    <>
      <EventGridLazyLoaded
        id={id}
        items={items}
        title={title}
        isLessThanLaptop={isLessThanLaptop}
        language={language}
        organizationSlug={organizationSlug}
        itemsPerRow={itemsPerRow}
        itemsPerPage={itemsPerPage}
      />
    </>
  )
}

export default EventsGridLoader
